"use client";
import { jsx as o, jsxs as R } from "react/jsx-runtime";
import { Icon as l } from "../icon/icon.js";
import { useId as S, useRef as C, useState as _, useEffect as k } from "react";
import b from "clsx";
import { useScroll as I, useWindowSize as L } from "react-use";
import { useDraggable as W } from "react-use-draggable-scroll";
import { d as B, e as F } from "../../virginmediao2-momentum-icons-icons-far-BWte5zss.js";
import '../../assets/tabs.css';const n = {
  "tabs-container": "_tabs-container_vwxhv_1",
  "tabs-container--breakout": "_tabs-container--breakout_vwxhv_5",
  "tabs-container__head": "_tabs-container__head_vwxhv_9",
  "tabs-container__controls": "_tabs-container__controls_vwxhv_17",
  "tabs-container__navigation": "_tabs-container__navigation_vwxhv_34",
  "tabs-container__navigation-control": "_tabs-container__navigation-control_vwxhv_47",
  "tabs-container__controls--justify-center": "_tabs-container__controls--justify-center_vwxhv_117",
  "tabs-container__controls--justify-end": "_tabs-container__controls--justify-end_vwxhv_121"
}, H = ({
  children: f,
  breakout: v,
  controls: r,
  className: d,
  justify: s = "start"
}) => {
  const a = S(), t = C(null), { events: h } = W(t, {
    isMounted: !!t
  }), [u, m] = _(!1), [g, x] = _(!1), { x: e } = I(t), { width: w } = L();
  k(() => {
    var c, i;
    const j = ((c = t.current) == null ? void 0 : c.scrollWidth) || 1 / 0, N = e + (((i = t.current) == null ? void 0 : i.offsetWidth) || 1 / 0);
    m(e > 30), x(N < j - 30);
  }, [e, t, w]);
  const y = () => {
    t.current && t.current.scrollBy({ left: -200, behavior: "smooth" });
  }, p = () => {
    t.current && t.current.scrollBy({ left: 200, behavior: "smooth" });
  };
  return /* @__PURE__ */ o(
    "div",
    {
      className: b(
        {
          [n["tabs-container"]]: !0,
          [n["tabs-container--breakout"]]: v
        },
        d
      ),
      children: /* @__PURE__ */ R("div", { className: n["tabs-container__head"], children: [
        r && /* @__PURE__ */ o("div", { className: n["tabs-container__navigation"], children: /* @__PURE__ */ o(
          "button",
          {
            className: n["tabs-container__navigation-control"],
            onClick: y,
            "aria-controls": a,
            disabled: !u,
            children: /* @__PURE__ */ o(l, { icon: B })
          }
        ) }),
        /* @__PURE__ */ o(
          "div",
          {
            id: a,
            ref: t,
            className: b({
              [n["tabs-container__controls"]]: !0,
              [n["tabs-container__controls--justify-center"]]: s === "center",
              [n["tabs-container__controls--justify-end"]]: s === "end"
            }),
            role: "tablist",
            ...h,
            children: f
          }
        ),
        r && /* @__PURE__ */ o("div", { className: n["tabs-container__navigation"], children: /* @__PURE__ */ o(
          "button",
          {
            className: n["tabs-container__navigation-control"],
            "aria-controls": a,
            onClick: p,
            disabled: !g,
            children: /* @__PURE__ */ o(l, { icon: F })
          }
        ) })
      ] })
    }
  );
};
export {
  H as Tabs
};
